


import React, { useRef } from 'react'
import ShowInterest from '../../../Common/Container/showintrestCon'
import VideoFrame from '../../../Common/Components/VideoFrame'
import Banner from '../../../Common/Components/Banner'
import { BannerData, CarouselData1, CarouselData2, CarouselData3, CarouselData4, CarouselData5, CarouselData6, CarouselData7, CarouselData8, CircleData, DetailInfo, FaqData, TrimData, } from "./Data"
import SeltosNavbar from './SeltosNavbar'
import Carousel from './Carousel'
import CarModel from '../../../Common/Components/CarModel'
import DetailedInfo from '../../../Common/Components/DetailedInfo'
import MeetTheFamily from '../../../Common/Components/MeetTheFamily'
import VerticalCarousel from './VerticalCarousel'
import CarouselPart from '../../../Common/Components/CarouselPart'
import Faq from '../../../Common/Components/Faq'
import VideoSection from './VideoSection'

function NewSeltos() {
  // Create refs for all sections
  const exteriorRef = useRef(null);
  const interiorRef = useRef(null);
  const performanceRef = useRef(null);
  const safetyRef = useRef(null);
  const adasRef = useRef(null);
  const connectivityRef = useRef(null);
  const comfortRef = useRef(null);
  const convenienceRef = useRef(null);

  // Function to scroll to section
  // const scrollToSection = (sectionName) => {
  //   let ref = null;
    
  //   switch(sectionName) {
  //     case 'exterior':
  //       ref = exteriorRef;
  //       break;
  //     case 'interior':
  //       ref = interiorRef;
  //       break;
  //     case 'performance':
  //       ref = performanceRef;
  //       break;
  //     case 'safety':
  //       ref = safetyRef;
  //       break;
  //     case 'adas':
  //       ref = adasRef;
  //       break;
  //     case 'connectivity':
  //       ref = connectivityRef;
  //       break;
  //     case 'comfort':
  //       ref = comfortRef;
  //       break;
  //     case 'convenience':
  //       ref = convenienceRef;
  //       break;


       
  //     default:
  //       return;
  //   }

  //   if (ref && ref.current) {
  //     const navbar = document.querySelector('.seltos-navbar');
  //     const navbarHeight = navbar ? navbar.offsetHeight : 80;
      
  //     const elementPosition = ref.current.offsetTop;
  //     const offsetPosition = elementPosition - navbarHeight;
      
  //     window.scrollTo({
  //       top: offsetPosition,
  //       behavior: "smooth"
  //     });
  //   }
  // };
const scrollToSection = (sectionName) => {
  let ref = null;

  switch(sectionName) {
    case 'exterior':
      ref = exteriorRef;
      break;
    case 'interior':
      ref = interiorRef;
      break;
    case 'performance':
      ref = performanceRef;
      break;
    case 'safety':
      ref = safetyRef;
      break;
    case 'adas':
      ref = adasRef;
      break;
    case 'connectivity':
      ref = connectivityRef;
      break;
    case 'comfort':
      ref = comfortRef;
      break;
    case 'convenience':
      ref = convenienceRef;
      break;
    case 'showInterest':          // 🔥 ADD THIS
      ref = showInterestRef;
      break;
    default:
      return;
  }

  if (ref && ref.current) {
    const navbar = document.querySelector('.seltos-navbar');
    const navbarHeight = navbar ? navbar.offsetHeight : 80;

    const elementPosition = ref.current.offsetTop;
    const offsetPosition = elementPosition - navbarHeight;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }
};

  const showInterestRef = useRef(null);
  
  return (
    <>
      <Banner bannerData={BannerData} />
      <SeltosNavbar scrollToSection={scrollToSection} />
      <Carousel />

      <CarModel 
        model="Seltos"
        bgCar={"https://firebasestorage.googleapis.com/v0/b/trupti-kia.firebasestorage.app/o/NEWSELTOS%2Fvideo%2FNewSeltos.mp4?alt=media&token=05878544-9d5c-4b24-a2f2-6ecac11877ca"}
        CircleData={CircleData}
      />


<VideoSection
title="The game changer has arrived."
subtitle="Experience the Badass features of the all-new Seltos. Watch the product film now."
videoId="7Sdabn2S-PQ"
/>
      <MeetTheFamily TrimData={TrimData} data={CircleData} />

      <div ref={showInterestRef}  id="show-interest">
        <ShowInterest someValue="newseltos" />
      </div>

      {/* Wrap each section in a div with ref */}
      <div ref={exteriorRef} className="section-wrapper">
        <VerticalCarousel
          data={CarouselData1[0]}
          imageOnLeft={false}
        />
      </div>

      <div ref={interiorRef} className="section-wrapper">
        {CarouselData2.map((item, index) => (
          <CarouselPart key={index} data={item} />
        ))}
      </div>

      <div ref={performanceRef} className="section-wrapper">
        <VerticalCarousel
          data={CarouselData3[0]}
          imageOnLeft={true}
        />
      </div>

      <div ref={safetyRef} className="section-wrapper">
        {CarouselData4.map((item, index) => (
          <CarouselPart key={index} data={item} />
        ))}
      </div>

      <div ref={adasRef} className="section-wrapper">
        <VerticalCarousel
          data={CarouselData5[0]}
          imageOnLeft={false}
        />
      </div>

      <div ref={connectivityRef} className="section-wrapper">
        {CarouselData6.map((item, index) => (
          <CarouselPart key={index} data={item} />
        ))}
      </div>

      <div ref={comfortRef} className="section-wrapper">
        <VerticalCarousel
          data={CarouselData7[0]}
          imageOnLeft={true}
        />
      </div>

      <div ref={convenienceRef} className="section-wrapper">
        {CarouselData8.map((item, index) => (
          <CarouselPart key={index} data={item} />
        ))}
      </div>

      {/* <VideoFrame videoUrl="https://www.youtube.com/live/orFDNiKp0YQ?si=wJQ7pAoxphv0NYhc" /> */}

      <DetailedInfo 
        DetailInfo={DetailInfo} 
        onScrollToInterest={() => {
          if (showInterestRef.current) {
            showInterestRef.current.scrollIntoView({ behavior: "smooth" });
          }
        }} 
      />
      <Faq FaqData={FaqData} />
    </>
  )
}

export default NewSeltos